import axios from 'axios';

// export const API_URL = 'http://api.ovlm97.fr:1337/api';
// export const API_BASE_URL = 'http://api.ovlm97.fr:1337';
export const API_URL = 'https://api.ovlm97.fr/api';
export const API_BASE_URL = 'https://api.ovlm97.fr';
export const API_TOKEN = '2e311e1ab4b950a68388b120c2cd68911e6e56a8cfbb80c743e77b878da95b47308592ccd06d701da0de5def9cd9ed5ac6e3ea3dca1697cd9b3815af9dacc205b268a140b8616c3d92aac9c60e10240eae97fa32350055e557eb2f391c518a07f137abf573c6e4b9dc47d771ef6102aba412375f21d44b579934f8f2a49e635e';
// export const WEBSITE_URL = 'http://ovlm97.fr:3001/';
export const WEBSITE_URL = 'https://ovlm97.fr/';

// Create API configuration with optional custom auth
const createAPI = (customToken = null) => {
  // Create a new Axios instance
  const api = axios.create({
      baseURL: API_URL,
  });

  // Add a request interceptor to add the authorization header
  api.interceptors.request.use(
      (config) => {
          // Use custom token if provided, otherwise fall back to default
          const token = customToken || API_TOKEN;
          if (token) {
              config.headers['Authorization'] = `Bearer ${token}`;
          }
          return config;
      },
      (error) => {
          return Promise.reject(error);
      }
  );

  return api;
};

// Default API instance with default token
const defaultApi = createAPI();

// Example GET request
export const getData = (endpoint) => {
  return defaultApi.get(endpoint);
};

// Example GET request with custom token
export const getDataWithAuth = (endpoint, customToken) => {
  const customApi = createAPI(customToken);
  return customApi.get(endpoint);
};

// Example POST request
export const postData = (endpoint, data) => {
  return defaultApi.post(endpoint, data);
};

// Example POST request with custom token
export const postDataWithAuth = (endpoint, data, customToken) => {
  const customApi = createAPI(customToken);
  return customApi.post(endpoint, data);
};

// Example PUT request
export const putData = (endpoint, data) => {
  return defaultApi.put(endpoint, data);
};

// Example DELETE request
export const deleteData = (endpoint) => {
  return defaultApi.delete(endpoint);
};

export default defaultApi;